import { configureStore } from '@reduxjs/toolkit';
import { env } from 'next-runtime-env';

import { geoserverApi } from '../api/geoserverApi';
import { itascaApi } from '../api/itascaserverApi';
import rootReducer from '../reducers';
import {
  addCustomizationListener,
  addFeatureListener,
  clearAllFeaturesListener,
  removeFeatureByFeatureTypeIdListener,
  removeFeatureByIdListener,
  updateFeatureByIdListener,
} from './listeners';

// Essentially don't show these values in our state when viewing it in redux devtools
const stateSanitizer = (state) => ({
  ...state,
  boundary: '<<LONG_BLOB>>',
  draw: '<<LONG_BLOB>>',
  drawV2: '<<LONG_BLOB>>',
  map: '<<LONG_BLOB>>',
});

export const makeStore = () => {
  return configureStore(
    {
      devTools:
        env('NEXT_PUBLIC_NODE_ENV') !== 'production'
          ? {
              // this will filter out most of the mapbox actions
              actionsDenylist: [
                'draw-v2/setDrawTool',
                'draw-v2/clearDrawMode',
                'draw-v2/incrementPolygonClick',
                'draw-v2/setIsDrawing',
                'draw-v2/setIsHoveringOverVertex',
                'draw-v2/setMode',
                'boundary/clearAllBoundary',
                'boundary/clearBoundary',
                'boundary/removeBoundaryByID',
                'boundary/removeBoundaryByIndex',
                'boundary/setBoundary',
                'boundary/setCombinedBoundaries',
              ],
              // serialize: true,
              stateSanitizer,
            }
          : false,
      middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
          serializableCheck: false,
          serialize: true,
        })
          .prepend(addFeatureListener.middleware)
          .prepend(addCustomizationListener.middleware)
          .prepend(removeFeatureByIdListener.middleware)
          .prepend(removeFeatureByFeatureTypeIdListener.middleware)
          .prepend(clearAllFeaturesListener.middleware)
          .prepend(updateFeatureByIdListener.middleware)
          .concat(geoserverApi.middleware)
          .concat(itascaApi.middleware),
      reducer: rootReducer,
    }

    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
  );
};

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof makeStore>;
export type AppDispatch = AppStore['dispatch'];
